import { MdPhone, MdMail } from 'react-icons/md'

const Header = () => {
  return (
    <header className='header' id='home'>
      <div className='header-container'>
        <h1>CNC obrábění Duben</h1>
        <div className='header-subtitle'>
          Zakázková výroba přesných strojních dílů
        </div>
        <div className='header-cta'>
          <a href='tel:+420601565735' className='header-cta-item'>
            <MdPhone className='header-cta-item-icon' />
            +420 601 565 735
          </a>
          <a href='mailto:cnc.duben@seznam.cz' className='header-cta-item'>
            <MdMail className='header-cta-item-icon' />
            cnc.duben@seznam.cz
          </a>
        </div>
      </div>
    </header>
  )
}

export default Header
